var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUserPersonalDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 128,
    viewBox: "0 0 384 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 128,
    rx: 16,
    fill: "#49B3FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.627 73.3725C211.142 69.8873 206.994 67.3071 202.467 65.7453C207.315 62.4064 210.5 56.8185 210.5 50.5C210.5 40.2991 202.201 32 192 32C181.799 32 173.5 40.2991 173.5 50.5C173.5 56.8185 176.685 62.4064 181.533 65.7453C177.007 67.3071 172.858 69.8873 169.373 73.3725C163.329 79.4166 160 87.4525 160 96H165C165 81.1121 177.112 69 192 69C206.888 69 219 81.1121 219 96H224C224 87.4525 220.671 79.4166 214.627 73.3725ZM192 64C184.556 64 178.5 57.944 178.5 50.5C178.5 43.056 184.556 37 192 37C199.444 37 205.5 43.056 205.5 50.5C205.5 57.944 199.444 64 192 64Z",
    fill: "#363B4D",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUserPersonalDataIcon);
export default __webpack_public_path__ + "static/media/ProfileUserPersonalDataIcon.3bd3f4c5cb893a43ee57a7727ac26596.svg";
export { ForwardRef as ReactComponent };